// extracted by mini-css-extract-plugin
export default {"radio":"RadioButton_radio__8cx38","label":"RadioButton_label__k2y6i"};